"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductSeriesEditViewModel = instanceOfProductSeriesEditViewModel;
exports.ProductSeriesEditViewModelFromJSON = ProductSeriesEditViewModelFromJSON;
exports.ProductSeriesEditViewModelFromJSONTyped = ProductSeriesEditViewModelFromJSONTyped;
exports.ProductSeriesEditViewModelToJSON = ProductSeriesEditViewModelToJSON;
exports.ProductSeriesEditViewModelToJSONTyped = ProductSeriesEditViewModelToJSONTyped;
/**
 * Check if a given object implements the ProductSeriesEditViewModel interface.
 */
function instanceOfProductSeriesEditViewModel(value) {
    if (!('psCompanyNO' in value) || value['psCompanyNO'] === undefined)
        return false;
    if (!('psProductSeriesName' in value) || value['psProductSeriesName'] === undefined)
        return false;
    return true;
}
function ProductSeriesEditViewModelFromJSON(json) {
    return ProductSeriesEditViewModelFromJSONTyped(json, false);
}
function ProductSeriesEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'psProductSeriesNO': json['psProductSeriesNO'] == null ? undefined : json['psProductSeriesNO'],
        'psCompanyNO': json['psCompanyNO'],
        'psProductSeriesName': json['psProductSeriesName'],
        'psWebSeriesName': json['psWebSeriesName'] == null ? undefined : json['psWebSeriesName'],
        'psManIntroduction': json['psManIntroduction'] == null ? undefined : json['psManIntroduction'],
        'psRemark': json['psRemark'] == null ? undefined : json['psRemark'],
        'psUseStatus': json['psUseStatus'] == null ? undefined : json['psUseStatus'],
        'psDISABLEDDATE': json['psDISABLED_DATE'] == null ? undefined : json['psDISABLED_DATE'],
    };
}
function ProductSeriesEditViewModelToJSON(json) {
    return ProductSeriesEditViewModelToJSONTyped(json, false);
}
function ProductSeriesEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'psProductSeriesNO': value['psProductSeriesNO'],
        'psCompanyNO': value['psCompanyNO'],
        'psProductSeriesName': value['psProductSeriesName'],
        'psWebSeriesName': value['psWebSeriesName'],
        'psManIntroduction': value['psManIntroduction'],
        'psRemark': value['psRemark'],
        'psUseStatus': value['psUseStatus'],
        'psDISABLED_DATE': value['psDISABLEDDATE'],
    };
}
